import { Checkbox, DataSource, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingCreditRebillSlideout extends Layout {
    checkboxCreateCreditMemo: Checkbox;
    checkboxRetransfer: Checkbox;
    panelNewCustomer: Panel;
    sourceBillingHistory: DataSource;
    switchNewCustomer: Switch;
    tableBillingHistory: Table;
    textboxNewCustomerId: Textbox;
    textboxNumber: Textbox;
    textboxReason: Textbox;
    textboxRebillBy: Textbox;
}
